// Mock data for British Supplements redesign. Replace with backend later.
export const LOGO = "https://customer-assets-m6fa6gv7.emergentagent.net/job_clean-supply-refresh/artifacts/rm30fo5u_download%20%281%29.jpeg";
export const LOGO_ROUND = "https://customer-assets-m6fa6gv7.emergentagent.net/job_clean-supply-refresh/artifacts/ofxypdxn_download%20%281%29.jpeg";
// Default explainer video (TikTok). Each product will get its own id later.
export const DEFAULT_VIDEO_ID = "7544084393380482327";
// Brand-wide trust figures (shown as sample until Judge.me is connected for live data)
export const BRAND_TRUST = { reviews: 46615, rating: 4.86, shipped: 300000 };
// Sample reviews shown until Judge.me is connected (real reviews replace these)
export const SAMPLE_REVIEWS = [
  { name: "Susan R.", rating: 5, title: "Life changing", body: "On an optimal dose now and I thank Chris for giving us clean vitamins without all the bulking nasties in. Wouldn't buy anywhere else." },
  { name: "Lynne M.", rating: 5, title: "Best ones out there", body: "Been buying from British Supplements for years. The difference in my pain levels and brain fog when I run out tells me everything. I just don't trust other brands." },
  { name: "Robin H.", rating: 5, title: "That feel-good factor", body: "Noticeably more energy and wellbeing within weeks. Rapid turnaround on delivery too. Just do it and get on with living as you should again." },
  { name: "Timothy R.", rating: 5, title: "Best supplier of supplements", body: "Started using them a few years back and have never been disappointed in the service or products. I fully trust the quality." },
];
// Full horizontal brand logo for the header
export const LOGO_HEADER = "https://customer-assets-m6fa6gv7.emergentagent.net/job_clean-supply-refresh/artifacts/yne27mvb_british-supplements-new-logo-website-header.webp";
const CDN = "https://cdn.shopify.com/s/files/1/0052/4369/9274/files/";
const img = (name) => `/products/${name}.jpg`;

export const CATEGORIES = [
  { key: "men", label: "Men", blurb: "Strength, drive & daily performance", image: "https://images.pexels.com/photos/5319373/pexels-photo-5319373.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { key: "women", label: "Women", blurb: "Beauty, balance & natural vitality", image: "https://images.unsplash.com/photo-1656962131411-4da99ce65d36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxuYXR1cmFsJTIwd2VsbG5lc3N8ZW58MHx8fGdyZWVufDE3OTA5MzAzODl8MA&ixlib=rb-4.1.0&q=85" },
  { key: "men40", label: "Men Over 40", blurb: "Testosterone, joints & longevity", image: "https://images.unsplash.com/photo-1532092367580-3bd5bc78dd9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHx3ZWxsbmVzcyUyMGhlcmJzfGVufDB8fHx8MTc5MDkzMDM5NXww&ixlib=rb-4.1.0&q=85" },
  { key: "women40", label: "Women Over 40", blurb: "Hormones, bones & glow", image: "https://images.unsplash.com/photo-1715679364571-131476ba4ce3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxuYXR1cmFsJTIwd2VsbG5lc3N8ZW58MHx8fGdyZWVufDE3OTA5MzAzODl8MA&ixlib=rb-4.1.0&q=85" },
  { key: "bundles", label: "Bundles", blurb: "Save more with curated stacks", image: "https://images.unsplash.com/photo-1610970884954-4d376ecba53f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHx3ZWxsbmVzcyUyMGhlcmJzfGVufDB8fHx8MTc5MDkzMDM5NXww&ixlib=rb-4.1.0&q=85" },
  { key: "sale", label: "Sale", blurb: "Clean supplements, cleaner prices", image: "https://static.prod-images.emergentagent.com/jobs/eb1332e6-cfcf-4328-a73d-c87fbfb0ba3d/images/f2d89ba27fb36b570cc7be6f9142471ea91bf7da857159454ad1d0a10cf37b57.jpeg" },
];

export const PRODUCTS = [
  {
    id: "mega-mag", slug: "clean-genuine-magnesium-mega-mag",
    name: "Clean Genuine Magnesium 1,404mg (Mega Mag)", short: "Mega Magnesium",
    price: 24.99, compareAt: null, rating: 4.9, reviews: 1284,
    image: img("clean-genuine-magnesium-1404mg-mega-mag-1727863"),
    categories: ["men", "women", "men40", "women40"], tags: ["sleep", "muscle", "bestseller"],
    badge: "Bestseller",
    description: "A triple-blend magnesium at a genuine 1,404mg per serving. No anti-caking agents, no magnesium stearate — just clean magnesium for sleep, mood and muscle recovery."
  },
  {
    id: "ashwagandha", slug: "clean-genuine-ashwagandha",
    name: "Clean Genuine Ashwagandha + Uptake Blend", short: "Ashwagandha",
    price: 21.99, compareAt: null, rating: 4.8, reviews: 963,
    image: img("clean-genuine-ashwagandha-uptake-blend-6705605"),
    categories: ["men", "women", "men40", "women40"], tags: ["stress", "sleep", "bestseller"],
    badge: "Bestseller",
    description: "Full-spectrum KSM ashwagandha extract with 22.54mg of withanolides, plus our uptake blend to help your body absorb more of what matters."
  },
  {
    id: "turmeric", slug: "clean-indian-turmeric",
    name: "Clean Genuine Indian Turmeric Extract + Uptake Blend", short: "Indian Turmeric",
    price: 22.99, compareAt: null, rating: 4.9, reviews: 1507,
    image: img("clean-genuine-indian-turmeric-extract-uptake-blend-2848177"),
    categories: ["men", "women", "men40", "women40"], tags: ["joints", "immunity", "bestseller"],
    badge: "Bestseller",
    description: "Real turmeric made from the root (never lab-made GMO curcumin) delivering 497mg curcumin. Clean, strong and nasty-free."
  },
  {
    id: "l-threonate", slug: "clean-magnesium-l-threonate",
    name: "Clean Genuine Magnesium L-Threonate + Uptake Blend", short: "Magnesium L-Threonate",
    price: 29.99, compareAt: null, rating: 4.8, reviews: 412,
    image: img("clean-genuine-magnesium-l-threonate-uptake-blend-7715820"),
    categories: ["men", "women", "men40", "women40"], tags: ["focus", "sleep"],
    description: "The form of magnesium that crosses the blood-brain barrier — for focus, memory and calm. Clean, with our signature uptake blend."
  },
  {
    id: "echinacea", slug: "clean-echinacea",
    name: "Clean Genuine Echinacea Extract + Uptake Blend", short: "Echinacea",
    price: 18.99, compareAt: null, rating: 4.7, reviews: 288,
    image: img("clean-genuine-echinacea-extract-uptake-blend-7496342"),
    categories: ["men", "women", "men40", "women40"], tags: ["immunity"],
    description: "Stop a cold in its tracks. High-strength echinacea extract to support your immune system through the seasons."
  },
  {
    id: "milk-thistle", slug: "clean-milk-thistle",
    name: "Clean Genuine Milk Thistle Extract + Uptake Blend", short: "Milk Thistle",
    price: 19.99, compareAt: null, rating: 4.8, reviews: 341,
    image: img("clean-genuine-milk-thistle-extract-uptake-blend-2732718"),
    categories: ["men", "women", "men40", "women40"], tags: ["detox", "liver"],
    description: "Milk thistle in a veg capsule — nothing else. Supports healthy liver function and natural detoxification."
  },
  {
    id: "vitamin-a", slug: "clean-vitamin-a",
    name: "Clean Genuine Vitamin A", short: "Vitamin A",
    price: 14.99, compareAt: null, rating: 4.7, reviews: 176,
    image: img("clean-genuine-vitamin-a-supplement-3789054"),
    categories: ["men", "women", "men40", "women40"], tags: ["skin", "immunity"],
    description: "Clean genuine Vitamin A to support vision, skin and immune health. No fillers, no nasties."
  },
  {
    id: "creatine", slug: "clean-creatine-monohydrate",
    name: "Clean Genuine Creatine Monohydrate 1,186mg", short: "Creatine Monohydrate",
    price: 23.99, compareAt: null, rating: 4.9, reviews: 629,
    image: img("clean-genuine-creatine-monohydrate-1186mg-per-serving-2648796"),
    categories: ["men", "men40"], tags: ["muscle", "strength", "performance"],
    description: "Pure creatine monohydrate — the most researched performance supplement on earth. For strength, power and lean muscle."
  },
  {
    id: "ecdysterone", slug: "clean-ecdysterone",
    name: "Clean Genuine Ecdysterone 629mg", short: "Ecdysterone",
    price: 34.99, compareAt: null, rating: 4.8, reviews: 203,
    image: img("clean-genuine-ecdysterone-629mg-8883381"),
    categories: ["men", "men40"], tags: ["muscle", "performance"],
    badge: "New",
    description: "A naturally occurring plant steroid prized by athletes for lean muscle and recovery. Clean and high-strength."
  },
  {
    id: "plant-sterols", slug: "clean-plant-sterols",
    name: "Clean Plant Sterols 95% Phytosterol", short: "Plant Sterols",
    price: 20.99, compareAt: null, rating: 4.9, reviews: 154,
    image: img("clean-plant-sterols-95-phytosterol-9384828"),
    categories: ["men40", "women40"], tags: ["heart", "cholesterol"],
    description: "95% phytosterols to naturally support healthy cholesterol levels. A clean alternative read loved by our customers."
  },
  {
    id: "artichoke", slug: "clean-artichoke",
    name: "Clean Artichoke (35mg Cynarin)", short: "Artichoke Extract",
    price: 17.99, compareAt: null, rating: 4.7, reviews: 97,
    image: img("clean-artichoke-35mg-cynarin-4033362"),
    categories: ["women", "women40", "men40"], tags: ["digestion", "liver"],
    description: "High-strength artichoke extract delivering 35mg cynarin to support digestion and liver health."
  },
  // Sale items (compareAt set)
  {
    id: "vitamin-a-sale", slug: "clean-vitamin-a-offer",
    name: "Clean Genuine Vitamin A (Offer)", short: "Vitamin A Offer",
    price: 11.99, compareAt: 14.99, rating: 4.7, reviews: 176,
    image: img("clean-genuine-vitamin-a-supplement-3789054"),
    categories: ["sale", "men", "women"], tags: ["skin", "immunity", "sale"],
    badge: "Sale",
    description: "Limited run of our Clean Vitamin A at a cleaner price. No pretend sales — a genuine reduction while stocks last."
  },
  {
    id: "echinacea-sale", slug: "clean-echinacea-offer",
    name: "Clean Echinacea Extract (Offer)", short: "Echinacea Offer",
    price: 14.99, compareAt: 18.99, rating: 4.7, reviews: 288,
    image: img("clean-genuine-echinacea-extract-uptake-blend-7496342"),
    categories: ["sale", "women", "women40"], tags: ["immunity", "sale"],
    badge: "Sale",
    description: "Seasonal offer on our high-strength Echinacea. Support your immune system for less."
  },
  {
    id: "milk-thistle-sale", slug: "clean-milk-thistle-offer",
    name: "Clean Milk Thistle Extract (Offer)", short: "Milk Thistle Offer",
    price: 15.99, compareAt: 19.99, rating: 4.8, reviews: 341,
    image: img("clean-genuine-milk-thistle-extract-uptake-blend-2732718"),
    categories: ["sale", "men40", "women40"], tags: ["detox", "sale"],
    badge: "Sale",
    description: "A genuine reduction on our clean Milk Thistle — liver support with nothing added."
  },
  // Bundles
  {
    id: "bundle-mens-performance", slug: "bundle-mens-performance",
    name: "Men's Performance Stack", short: "Men's Performance Stack",
    price: 59.99, compareAt: 72.97, rating: 4.9, reviews: 212,
    image: img("clean-genuine-creatine-monohydrate-1186mg-per-serving-2648796"),
    categories: ["bundles", "men"], tags: ["muscle", "strength", "bundle"],
    badge: "Save £13",
    bundleItems: ["Creatine Monohydrate", "Ecdysterone", "Mega Magnesium"],
    description: "Everything a man needs to train, recover and perform — Creatine, Ecdysterone and Mega Magnesium. Bundled to save you money."
  },
  {
    id: "bundle-womens-glow", slug: "bundle-womens-glow",
    name: "Women's Glow & Calm Stack", short: "Women's Glow Stack",
    price: 54.99, compareAt: 65.97, rating: 4.9, reviews: 184,
    image: img("clean-genuine-ashwagandha-uptake-blend-6705605"),
    categories: ["bundles", "women"], tags: ["stress", "skin", "bundle"],
    badge: "Save £11",
    bundleItems: ["Ashwagandha", "Vitamin A", "Mega Magnesium"],
    description: "Calm the mind and support natural radiance with Ashwagandha, Vitamin A and Mega Magnesium."
  },
  {
    id: "bundle-over40", slug: "bundle-over-40-longevity",
    name: "Over 40 Longevity Stack", short: "Over 40 Longevity Stack",
    price: 57.99, compareAt: 70.97, rating: 4.9, reviews: 139,
    image: img("clean-plant-sterols-95-phytosterol-9384828"),
    categories: ["bundles", "men40", "women40"], tags: ["heart", "joints", "bundle"],
    badge: "Save £13",
    bundleItems: ["Plant Sterols", "Indian Turmeric", "Magnesium L-Threonate"],
    description: "Built for life after 40 — Plant Sterols, Turmeric and Magnesium L-Threonate for heart, joints and a sharp mind."
  },
  {
    id: "bundle-immunity", slug: "bundle-immunity",
    name: "Everyday Immunity Stack", short: "Immunity Stack",
    price: 44.99, compareAt: 52.97, rating: 4.8, reviews: 98,
    image: img("clean-genuine-echinacea-extract-uptake-blend-7496342"),
    categories: ["bundles", "men", "women"], tags: ["immunity", "bundle"],
    badge: "Save £8",
    bundleItems: ["Echinacea", "Vitamin A", "Indian Turmeric"],
    description: "Keep your defences strong year-round with Echinacea, Vitamin A and Turmeric."
  },
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);
export const getByCategory = (key) => PRODUCTS.filter((p) => p.categories.includes(key));

export const BESTSELLERS = PRODUCTS.filter((p) => p.tags.includes("bestseller"));
export const NEW_ARRIVALS = PRODUCTS.filter((p) => p.badge === "New" || ["l-threonate", "ecdysterone", "plant-sterols", "artichoke"].includes(p.id));
export const SALE_ITEMS = PRODUCTS.filter((p) => p.categories.includes("sale"));
export const BUNDLE_ITEMS = PRODUCTS.filter((p) => p.categories.includes("bundles"));

// The anti-pharma "truth" story, adapted from brand copy.
export const STORY = {
  popupTitle: "The Truth",
  popupHeadline: "The story about making clean supplements that Big Pharma doesn't want you to know",
  popupBody: "99% of supplements aren't made for people — they're made for profit, double-bulked and packed with nasty fillers. We do the opposite. Discover why we're different.",
  intro: "Hi, my name is Chris and I own Real Health Supplements LTD, trading as British Supplements. I started this business because of the sorry state the food and supplement industry is in. Nothing is made for people — it's all made for profit. That's where we come in.",
  themVsUs: {
    them: [
      "Big Business & Big Government",
      "Big Pharma + the regulators (partners)",
      "Politicians who represent the gatekeepers",
      "Mass-produced, double-bulked powders",
      "Fillers: Magnesium Stearate, Silicon Dioxide, Titanium Dioxide, Talc...",
    ],
    us: [
      "The People & small business",
      "Made for humans, not machines",
      "Clean, high-strength, nasty-free",
      "Real roots & flowers — never lab-made GMO",
      "100% of what you came to buy. Nothing hidden.",
    ],
  },
  nastyList: "DiCalcium Phosphate, Anti-caking Agents (Silicon Dioxide & Magnesium Stearate), Tablet Coating, Crosslinked Cellulose Gum, Stearic Acid, Polydextrose, Titanium Dioxide & Iron Oxides, Maltodextrin, Talc, Sucrose, Calcium Carbonate, Shellac...",
  plan: [
    "Have around 200 natural supplement products with nothing added",
    "Open a manufacturing branch to protect free speech & quality",
    "Manufacture our own capsules (no one in the UK does this)",
    "Buy in roots & flowers to process our own powders",
    "Create a raw supplement line if we can",
    "Travel the world to source the very best ingredients",
  ],
  values: ["Fairness", "Integrity", "Respect", "Knowledge", "Constant Learning", "Trustworthiness"],
};

// Recent purchase "sold" notifications (bottom-left popup)
export const RECENT_PURCHASES = [
  { name: "Andrew", place: "Gloucester, England", product: "Mega Magnesium", image: img("clean-genuine-magnesium-1404mg-mega-mag-1727863"), ago: "2 minutes ago" },
  { name: "Nicole", place: "Cardiff, Wales", product: "Magnesium L-Threonate", image: img("clean-genuine-magnesium-l-threonate-uptake-blend-7715820"), ago: "6 minutes ago" },
  { name: "Dave", place: "Belfast, N. Ireland", product: "Ashwagandha", image: img("clean-genuine-ashwagandha-uptake-blend-6705605"), ago: "9 minutes ago" },
  { name: "Bernadette", place: "Manchester, England", product: "Indian Turmeric", image: img("clean-genuine-indian-turmeric-extract-uptake-blend-2848177"), ago: "12 minutes ago" },
  { name: "Margaret", place: "Glasgow, Scotland", product: "Plant Sterols", image: img("clean-plant-sterols-95-phytosterol-9384828"), ago: "15 minutes ago" },
  { name: "Timothy", place: "Leeds, England", product: "Creatine Monohydrate", image: img("clean-genuine-creatine-monohydrate-1186mg-per-serving-2648796"), ago: "18 minutes ago" },
  { name: "Amina", place: "Birmingham, England", product: "Echinacea", image: img("clean-genuine-echinacea-extract-uptake-blend-7496342"), ago: "21 minutes ago" },
  { name: "Denise", place: "Liverpool, England", product: "Milk Thistle", image: img("clean-genuine-milk-thistle-extract-uptake-blend-2732718"), ago: "24 minutes ago" },
  { name: "Jonathan", place: "Bristol, England", product: "Ecdysterone", image: img("clean-genuine-ecdysterone-629mg-8883381"), ago: "28 minutes ago" },
  { name: "Stephen", place: "Newcastle, England", product: "Artichoke Extract", image: img("clean-artichoke-35mg-cynarin-4033362"), ago: "33 minutes ago" },
];

// FAQ
export const FAQS = [
  { q: "What makes British Supplements 'clean'?", a: "Our products contain only what you came to buy, plus an uptake blend to help absorption. No magnesium stearate, no silicon dioxide, no titanium dioxide, no artificial fillers or bulking agents. Just genuine, high-strength ingredients." },
  { q: "Where are your supplements made?", a: "Everything is manufactured in the UK. We're a British business that pays its taxes and is built to genuinely help people \u2014 not big business or big pharma." },
  { q: "What is the 'uptake blend'?", a: "A small, natural blend we add to most products to help your body absorb more of the active ingredient. It's always clearly listed \u2014 we never hide anything." },
  { q: "How long does UK delivery take?", a: "Most UK orders are dispatched within 1\u20132 working days and arrive within 2\u20134 working days. Shipping is free on UK orders over \u00a340." },
  { q: "Do you ship internationally?", a: "Yes, we ship to many countries worldwide. Delivery times and costs are calculated at checkout based on your location." },
  { q: "Are your products suitable for vegetarians and vegans?", a: "The vast majority of our products use vegetable capsules and plant-based ingredients. Always check the individual product page for specifics." },
  { q: "Can I return a product?", a: "Yes. If you're not happy, contact us within 30 days. Please see our Returns & Refunds policy for full details." },
  { q: "Should I consult a doctor before taking supplements?", a: "If you are pregnant, breastfeeding, taking medication or have a medical condition, always consult your doctor or a qualified healthcare professional before starting any new supplement." },
];

// Legal / policy content (plain concept copy)
export const LEGAL = {
  disclaimer: {
    title: "Disclaimer",
    intro: "The information on this website is provided for general informational and educational purposes only and is not intended as medical advice.",
    sections: [
      { h: "Not Medical Advice", p: "Our products are food supplements and are not intended to diagnose, treat, cure or prevent any disease. Nothing on this site should be taken as a substitute for professional medical advice, diagnosis or treatment." },
      { h: "Consult a Professional", p: "Always seek the advice of your doctor or a qualified healthcare provider with any questions you may have regarding a medical condition, your diet, or before starting any new supplement \u2014 especially if you are pregnant, breastfeeding, under 18, or taking medication." },
      { h: "Individual Results", p: "Customer reviews and testimonials reflect individual experiences and are not a guarantee that you will achieve the same results. Supplements should not be used as a substitute for a varied, balanced diet and a healthy lifestyle." },
      { h: "Food Supplements", p: "Do not exceed the recommended daily dose. Keep out of reach of children. Store in a cool, dry place away from direct sunlight." },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    intro: "We respect your privacy and are committed to protecting the personal data you share with us.",
    sections: [
      { h: "Information We Collect", p: "We collect the information you provide when you create an account or place an order \u2014 such as your name, email, delivery address and order history \u2014 along with limited technical data to run and improve our website." },
      { h: "How We Use It", p: "Your data is used to process orders, provide customer support, send order updates, and (only with your consent) send marketing emails you can unsubscribe from at any time." },
      { h: "Sharing", p: "We never sell your data. We only share it with trusted partners who help us run our store, such as payment processors and delivery couriers, and only to the extent needed to fulfil your order." },
      { h: "Your Rights", p: "You have the right to access, correct or delete your personal data at any time. Contact us and we'll help." },
    ],
  },
  terms: {
    title: "Terms & Conditions",
    intro: "By using this website and placing an order, you agree to the following terms.",
    sections: [
      { h: "Orders", p: "All orders are subject to acceptance and availability. Prices are shown in GBP and include VAT where applicable. We reserve the right to refuse or cancel any order." },
      { h: "Pricing", p: "We price our products as fairly as we genuinely can. We don't run fake, permanent 'sales' \u2014 any reduction you see is a real reduction." },
      { h: "Shipping & Returns", p: "Free UK shipping on orders over \u00a340. If you're not satisfied, contact us within 30 days of receipt for a return or exchange in line with your statutory rights." },
      { h: "Liability", p: "Our products are food supplements. To the fullest extent permitted by law, our liability is limited to the value of the products you purchased. Nothing in these terms affects your statutory consumer rights." },
      { h: "Governing Law", p: "These terms are governed by the laws of the United Kingdom." },
    ],
  },
};

